module.exports = __webpack_public_path__ + "static/media/menu-apr-icon.ab9806fb.svg";